import request from '@/utils/request'

// 查询任务售后分页（后台）
export function pageTaskRefund(query) {
  return request({
    url: '/task/task/order/refund/page',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务售后详情（后台）
export function getTaskRefund(data) {
  return request({
    url: '/task/task/order/refund/detail',
    method: 'post',
    data: data
  })
}

// 审核任务售后（后台）
export function auditTaskRefund(data) {
  return request({
    url: '/task/task/order/refund/audit',
    method: 'post',
    data: data
  })
}

// 申请售后（APP端）
export function applyTaskRefund(data) {
  return request({
    url: '/api/v2/task/order/refund/apply',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 查询售后详情（APP端）
export function getAppTaskRefund(data) {
  return request({
    url: '/api/v2/task/order/refund/detail',
    method: 'post',
    data: data
  })
}

// 根据订单ID查询售后详情（APP端）
export function getAppTaskRefundByOrder(data) {
  return request({
    url: '/api/v2/task/order/refund/detailByOrder',
    method: 'post',
    data: data
  })
}

// 撤销售后（APP端）
export function backTaskRefund(data) {
  return request({
    url: '/api/v2/task/order/refund/back',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: data
  })
}

// 删除任务售后（后台）
export function delTaskRefund(data) {
  return request({
    url: '/task/task/order/refund/remove',
    method: 'post',
    data: data
  })
}
